import { Link } from 'react-router-dom';
import type { Movie } from '@/lib/movieTypes';
import { formatCount } from '@/lib/movieUtils';

interface MovieCardProps {
  movie: Movie;
  showSummary?: boolean;
}

export default function MovieCard({ movie, showSummary = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={movie.cover}
          alt={`${movie.title} - ${movie.subCategoryName}${movie.typeName}`}
          title={`${movie.title} ${movie.subCategoryName}${movie.typeName}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-semibold">
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-background-50 text-xs">
          {movie.subCategoryName}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-950 clamp-2 group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-1.5 flex items-center flex-wrap gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{movie.year}</span>
          <span className="whitespace-nowrap">{movie.region}</span>
          <span className="whitespace-nowrap flex items-center gap-1">
            <i className="ri-play-circle-line"></i>
            {formatCount(movie.playCount)}
          </span>
        </div>
        {showSummary && (
          <p className="mt-2 text-xs text-foreground-600 leading-relaxed clamp-2">{movie.summary}</p>
        )}
      </div>
    </Link>
  );
}